import { render, staticRenderFns } from "./accountsBar2.vue?vue&type=template&id=018f955a&"
import script from "./accountsBar2.vue?vue&type=script&lang=js&"
export * from "./accountsBar2.vue?vue&type=script&lang=js&"
import style0 from "./accountsBar2.vue?vue&type=style&index=0&id=018f955a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports